import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/config";

const RemarksPopup = ({
  open,
  handleClose,
  selectedTicketId,
  username,
  initialRemarks,
  processedname,
}) => {
  const [remarks, setRemarks] = useState("");

  const handleSaveRemarks = () => {
    axios
      .post(`${BASE_URL}admin/onboarding-team-remarks`, {
        onboarding_team_remarks: remarks,
        onboarding_team_name: username,
        ticket_obj_id: selectedTicketId,
      })
      .then((response) => {
        console.log("Remarks saved successfully:", response.data);
        setRemarks("");
        handleClose();
      })
      .catch((error) => {
        console.error("Error saving remarks:", error);
      });
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        className="
          absolute top-1/2 left-1/2 
          -translate-x-1/2 -translate-y-1/2 
          w-[90%] max-w-md
          bg-white shadow-2xl rounded-2xl
          p-6 flex flex-col gap-4
          transition-all duration-300 ease-in-out
          border border-gray-200
        "
      >
        {/* Title */}
        <Typography variant="h6" className="font-semibold text-gray-800">
          Add Remarks
        </Typography>

        {/* Textarea */}
        <TextField
          label="Write your remarks"
          multiline
          rows={4}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          fullWidth
          variant="outlined"
          className="rounded-lg"
        />

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 mt-2">
          <Button
            variant="outlined"
            onClick={handleClose}
            className="!rounded-lg !px-5 !py-2 !text-gray-700 hover:!bg-gray-100"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveRemarks}
            variant="contained"
            className="!bg-blue-600 hover:!bg-blue-700 !rounded-lg !px-5 !py-2"
          >
            Save
          </Button>
        </div>

        <Divider className="!my-3" />

        {/* Previous Remarks */}
        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
          <Typography variant="body2" className="text-gray-500">
            Previous Remarks:
          </Typography>
          <Typography variant="body1" className="mt-1 text-gray-800">
            {initialRemarks ? initialRemarks : "No remarks available"}
          </Typography>
          {processedname && (
            <Typography
              variant="subtitle2"
              className="mt-1 font-semibold text-blue-600"
            >
              – {processedname}
            </Typography>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default RemarksPopup;
